// extracted by mini-css-extract-plugin
export default {"toggleBlock":"ToggleBlock_toggleBlock__VawaU","toggleItemList":"ToggleBlock_toggleItemList__JADVs"};